import React, {ComponentType} from 'react';
import {withStyles} from '@wix/native-components-infra/dist/es/src/HOC/withStyles/withStyles';
import {withDefaultStyleParams} from '@wix/wixstores-client-common-components/dist/es/src/outOfIframes/defaultStyleParams/withDefaultStyleParams';
import {getStyleParamsWithDefaultsFunc} from './getStyleParamsWithDefaultsFunc';
import {initContext, Strategy, withGlobalsProvider} from './globalPropsContext';
import {IGallerySantaProps} from './types/galleryTypes';

export interface IGetWrappedComponentOptions {
  Component: React.ComponentType;
  globalPropsStrategy: Strategy<any>;
  withStyleStrategy: typeof withStyles;
  sliderGallery?: boolean;
}

export function getWrappedComponent({
  Component,
  globalPropsStrategy,
  withStyleStrategy,
  sliderGallery,
}: IGetWrappedComponentOptions) {
  initContext(globalPropsStrategy);
  let wrappedComponent: ComponentType<IGallerySantaProps>;
  wrappedComponent = withStyleStrategy(withGlobalsProvider(Component, sliderGallery), {
    strictMode: true,
  });
  wrappedComponent = withDefaultStyleParams(wrappedComponent, ({host}) => getStyleParamsWithDefaultsFunc(host));

  return wrappedComponent;
}
